module.exports = __webpack_public_path__ + "img/logo_s.2e862f86.svg";